import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { ProgressProvider } from "./context/ProgressContext";
import { PurchaseProvider } from "./context/PurchaseContext";
import { Layout } from "./components/layout/Layout";
import HomePage from "./pages/HomePage";
import ModulePage from "./pages/ModulePage";
import ResourcesPage from "./pages/ResourcesPage";
import CertificatePage from "./pages/CertificatePage";
import PurchasePage from "./pages/PurchasePage";
import PaymentSuccessPage from "./pages/PaymentSuccessPage";
import PaymentCancelPage from "./pages/PaymentCancelPage";
import AdminPage from "./pages/AdminPage";

function App() {
  return (
    <div className="App">
      <PurchaseProvider>
        <ProgressProvider>
          <BrowserRouter>
            <Layout>
              <Routes>
                <Route path="/" element={<HomePage />} />
                <Route path="/module/:slug" element={<ModulePage />} />
                <Route path="/resources" element={<ResourcesPage />} />
                <Route path="/certificate" element={<CertificatePage />} />
                <Route path="/purchase" element={<PurchasePage />} />
                <Route path="/payment/success" element={<PaymentSuccessPage />} />
                <Route path="/payment/cancel" element={<PaymentCancelPage />} />
                <Route path="/admin" element={<AdminPage />} />
              </Routes>
            </Layout>
          </BrowserRouter>
        </ProgressProvider>
      </PurchaseProvider>
    </div>
  );
}

export default App;
